exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// ./~/.2.5.3@core-js/library/modules/_object-gops.js
// module id = 35
// module chunks = 0